import React from 'react'
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';

const InfoHeader = (props) => { 
	const content = props.content;
    return (
		<div style={{maxWidth:"800px", textAlign:"center", margin:"0 auto 1em", padding:"0 1em"}}>
			<Typography sx={{lineHeight:"1.25"}}>
				{parse(content)}
			</Typography>
		</div>
	)
}

export default InfoHeader;
